import { DealerAccount } from "../../../../../../api/dealer/types";
import { DisplayDealerName } from "../../../../../../pages/preferences/types";

export type DealerAccountSortBy =
  | "dealer_name_asc"
  | "city_asc"
  | "dealer_number_asc"
  | "dealer_number_desc";

const compareFns: Record<
  DealerAccountSortBy,
  (accountOne: DealerAccount, accountTwo: DealerAccount) => number
> = {
  dealer_name_asc: (accountOne, accountTwo) =>
    (accountOne.name || "").localeCompare(accountTwo.name || ""),
  city_asc: (accountOne, accountTwo) =>
    (accountOne.location.city || "").localeCompare(
      accountTwo.location.city || ""
    ),
  dealer_number_asc: (accountOne, accountTwo) =>
    (accountOne.id || "").localeCompare(accountTwo.id || ""),
  dealer_number_desc: (accountOne, accountTwo) =>
    (accountTwo.id || "").localeCompare(accountOne.id || ""),
};

export const createDealerAccountMap = (
  accounts?: DealerAccount[],
  sortBy: DealerAccountSortBy = "dealer_name_asc",
  enableSorting: boolean = false
): Map<string, DealerAccount> => {
  if (!accounts || accounts.length === 0) {
    return new Map<string, DealerAccount>();
  }

  const [first, ...restAccounts] = accounts;
  const filteredAccounts = restAccounts.filter(Boolean);
  const sortedAccounts = enableSorting
    ? filteredAccounts.sort(compareFns[sortBy])
    : filteredAccounts;

  const map = new Map<string, DealerAccount>();
  if (first) {
    map.set(first.id, first);
  }
  sortedAccounts.forEach((account) => {
    map.set(account.id, account);
  });

  return map;
};

export const showDealerName = (userPreferences: any[]): boolean => {
  const displayDealerNamePref = userPreferences?.find(
    (pref: { key: string }) => pref.key === "display_dealer_name"
  );

  return displayDealerNamePref?.value === DisplayDealerName.YES;
};

export const createDisplayNameForDealer = (
  account: DealerAccount,
  displayDealerName: boolean = false
): string => {
  if (account?.location) {
    if (displayDealerName && account.name) {
      return `${account.id} ${account.name}, ${account.location?.city ?? ""}, ${
        account.location?.state ?? ""
      } ${account.location.country}`;
    }
    return `${account.id} ${account.location?.city ?? ""}, ${
      account.location?.state ?? ""
    } ${account.location.country}`;
  }
  return account.id;
};
